var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":_vm.type,"readonly":_vm.cReadonly},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.change($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }